import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import CommonDesktopHeader from '~/src/features/_layout/Header/desktop/components/CommonDesktopHeader';
import CommonMobileHeader from '~/src/features/_layout/Header/mobile/components/CommonMobileHeader';
import ProfileContainer from '~/src/features/_layout/Header/mobile/components/ProfileContainer';
import { selectAuthMenu } from '~/src/store/selectors/menu/selectMenu';

export const AuthHeader = () => {
    const newMenuItems = useSelector(selectAuthMenu);

    const CommonActions = useMemo(() => <ProfileContainer/>, []);

    return (
        <>
            <CommonDesktopHeader
                items={newMenuItems}
                ClientActions={CommonActions}
            />
            <CommonMobileHeader
                items={newMenuItems}
                CommonActions={{ Actions: CommonActions }}
                isAuth={true}
            />
        </>
    );
};
